import { useContext } from 'react';
import AppContext from '../../../AppContext';
import { RatioFormat, TextFormat } from '../../format';
import { DataResult } from '../../model/DataResult';
import AnnualChangeRowProps from './AnnualChangeRowProps';
import { renderYearValueWithCustomFormat, YEAR_CELL_CLASS } from './yearRenderUtils';

export default function IrisRow({ data }: AnnualChangeRowProps) {
  const { activeYearsMode } = useContext(AppContext);
  const showTenYearCells = activeYearsMode === 'TEN' && data.priorYearMinusFour !== undefined;

  function getIrisCell(irisData: DataResult) {
    if (irisData && irisData.value !== null) {
      return <RatioFormat {...irisData} className={YEAR_CELL_CLASS} />;
    } else {
      return <TextFormat {...irisData} className={YEAR_CELL_CLASS} />;
    }
  }

  return (
    <>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <RatioFormat {...data.industryMean} />
      {renderYearValueWithCustomFormat(data.currentYear, getIrisCell(data.currentYear))}
      {renderYearValueWithCustomFormat(data.priorYear, getIrisCell(data.priorYear))}
      {renderYearValueWithCustomFormat(data.priorYearMinusOne, getIrisCell(data.priorYearMinusOne))}
      {renderYearValueWithCustomFormat(data.priorYearMinusTwo, getIrisCell(data.priorYearMinusTwo))}
      {renderYearValueWithCustomFormat(data.priorYearMinusThree, getIrisCell(data.priorYearMinusThree))}
      {showTenYearCells && (
        <>
          {renderYearValueWithCustomFormat(data.priorYearMinusFour as DataResult, getIrisCell(data.priorYearMinusFour as DataResult))}
          {renderYearValueWithCustomFormat(data.priorYearMinusFive as DataResult, getIrisCell(data.priorYearMinusFive as DataResult))}
          {renderYearValueWithCustomFormat(data.priorYearMinusSix as DataResult, getIrisCell(data.priorYearMinusSix as DataResult))}
          {renderYearValueWithCustomFormat(data.priorYearMinusSeven as DataResult, getIrisCell(data.priorYearMinusSeven as DataResult))}
          {renderYearValueWithCustomFormat(data.priorYearMinusEight as DataResult, getIrisCell(data.priorYearMinusEight as DataResult))}
        </>
      )}
    </>
  );
}
